import { turpial } from "../turpial";

const StripeComponent = function(callback){
    if(typeof Stripe !== "undefined"){
        callback();
        return;
    }
    turpial.fetch({
        url: ["https://js.stripe.com/v3/"],
        ready: ()=>{
            callback();
        },
    })
}

export { StripeComponent }